import React, { useEffect } from 'react';
import PageSlug from './PageSlug';
import { useContent, useLoading } from '../hooks/customHooks';
import Brand from '../components/Brand';
import Footer from '../components/Footer';
import SocialShares from '../components/SocialShares/SocialShares';
import WhatsappButton from '../components/WhatsappButton';
import { Link } from 'react-router-dom';
import routeNames from '../constants/routeNames';
import QrCode from '../assets/images/qr-code.svg';

export default function MobileOnly() {
    const { content } = useContent();
    const { setLoading } = useLoading();
    const c = content?.pages?.mobile_only?.content;
    const s = content?.pages?.mobile_only?.settings;
    const g = content?.global_settings?.images;
    const showSocials = s?.footer_social;
    const whatsapp = s?.whatsapp;

    useEffect(() => {
        setLoading(false);
    }, []);

    return (
        <>
            <div className={`page-wrapper ${s?.bg && g?.bg ? 'has-bg' : ''}`}>
                {s?.bg && g?.bg && (
                    <div
                        className={`${s?.bg && g?.bg ? 'with-bg' : ''}`}
                        style={{ backgroundImage: s?.bg && g?.bg && `url(${g?.bg})` }}
                    ></div>
                )}
                {s?.header && g?.header && <Brand image={g?.header} />}
                <main>
                    {s?.logo && g?.logo && (
                        <section className="campaign-logo">
                            <Link to={routeNames.HOME} className="brand-logo">
                                <img className="header-title-image" alt="" src={g?.logo} />
                            </Link>
                        </section>
                    )}
                    <section
                        className={`main-content ${s?.bg && g?.bg ? 'transparent-container' : ''}`}
                    >
                        <section className="section-lite text-center card section-padding-small">
                            <PageSlug title={c?.title?.value}>
                                <img
                                    src={QrCode}
                                    alt="QR code"
                                    style={{
                                        width: '180px',
                                        maxWidth: '100%',
                                        marginBottom: '30px',
                                    }}
                                />

                                <p dangerouslySetInnerHTML={{ __html: c?.description?.value }}></p>
                            </PageSlug>
                        </section>
                    </section>
                    <section
                        className={
                            'transparent-container ' + (!showSocials && !whatsapp ? 'hidden' : '')
                        }
                    >
                        {showSocials && <SocialShares></SocialShares>}
                        {whatsapp && <WhatsappButton />}
                    </section>
                    {s?.footer && (
                        <Footer className={`${s?.bg && g?.bg ? 'transparent-container' : ''}`} />
                    )}
                </main>
            </div>
        </>
    );
}
